import config from "../../../config/config.json";

export const navbar = {
    data() {
        return {
            loading: false,
            endStatus: "true",
            timerSart: '',
            cat_id: "",
            textErrors: "",
            counter: 0,
            errors: '',
            isLoaderVisible: 'false',
            downloads: "",
            number: 160,
            text_error: "زمان شما به اتهام رسید است",
            numbers_in: "",
            timerText: "مطمین شوید که به اینترنت وصلی هستید در حال بسته آزمون",
            timeoutHandle: '00:00',
            lists: [],
            users: {},
            cate: {},
            leve: {
                preliminary: 'مقدماتی',
                hard: 'پیشرفته',
                medium: 'متوسط'
            },
            url: `${config.BASE_URL}/customers`
        }
    },

}